import { jsx as _jsx } from "react/jsx-runtime";
import { cx } from '../../../internal/cx.js';
/** A keyboard key or shortcut, e.g. <Kbd>⌘K</Kbd>. */
export function Kbd({ className, ...rest }) {
    return _jsx("kbd", { ...rest, className: cx('mn-kbd', className) });
}
//# sourceMappingURL=kbd.js.map